export function withoutCianDomain(url: string) {
  const urlPairs = url.split('cian.ru');

  return urlPairs[1] || urlPairs[0];
}
